import { useState } from 'react'
import { languageName } from '../lib/staffText'
import { Select } from './Select'
import { useLanguageChoice, useStaffText } from './StaffText'

/**
 * The language of the staff screens, chosen from the top bar: the only place a
 * language is chosen, shown only while there is more than one to choose (a
 * reviewer also sees unreleased ones, marked Draft). Each is written in its own name.
 */
export function LanguageMenu() {
  const { lang, say } = useStaffText()
  const choice = useLanguageChoice()
  const [busy, setBusy] = useState(false)
  if (!choice) return null
  return (
    <Select
      aria-label={say('entry.language')}
      title={say('entry.language')}
      size="sm"
      className="lang-menu"
      style={{ width: 'auto' }}
      value={lang}
      disabled={busy}
      options={choice.languages.map((code) => ({
        value: code,
        label: languageName(code),
        short: code.toUpperCase(),
        note: choice.drafts.includes(code) ? say('entry.languageDraft') : undefined,
      }))}
      onChange={(value) => {
        if (!value || value === lang || !choice.languages.includes(value)) return
        setBusy(true)
        choice.choose(value).finally(() => setBusy(false))
      }}
    />
  )
}
